/**
 * Get User Name Helper
 * Extracts user display name from auth user object (Supabase or compatible shape)
 */

export interface AuthUserForDisplay {
  firstName?: string | null
  lastName?: string | null
  username?: string | null
  primaryEmailAddress?: { emailAddress: string } | null
}

/**
 * Get user display name from auth user object
 * Priority: fullName > username > email prefix > 'You'
 */
export const getUserName = (user: AuthUserForDisplay | null | undefined): string => {
  if (!user) return 'You'

  const firstName = user.firstName || ''
  const lastName = user.lastName || ''
  const fullName = `${firstName} ${lastName}`.trim()

  if (fullName) return fullName
  if (user.username) return user.username
  if (user.primaryEmailAddress) {
    return user.primaryEmailAddress.emailAddress.split('@')[0]
  }

  return 'You'
}
